import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { Charge } from 'src/app/core/models/charge.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { AddChargeComponent } from './add-charge/add-charge.component';

type AddChargeModalResponse = OverlayEventDetail<{
	dismissed?: boolean;
}>;

@Component({
	selector: 'app-charges-tab',
	templateUrl: './charges-tab.component.html',
	styleUrls: ['./charges-tab.component.scss']
})
export class ChargesTabComponent implements OnInit {

	appointmentId: number;
	additionalCharges: Charge[];

	constructor(
		private modalController: ModalController,
		private activatedRoute: ActivatedRoute,
		private appointmentService: AppointmentService,
	) { }

	async ngOnInit(): Promise<void> {
		this.appointmentId = this.activatedRoute.snapshot.parent.parent.params?.id;
		await this.loadCharges();
	}

	async loadCharges(): Promise<void> {
		this.additionalCharges = await this.appointmentService.getAllCharges(this.appointmentId);
	}

	async onClickDeleteCharge(charge: Charge): Promise<void> {
		await this.appointmentService.removeCharge(this.appointmentId, charge);
		await this.loadCharges();
	}

	async onClickGoToAddCharge(): Promise<any> {
		const modal = await this.modalController.create({
			component: AddChargeComponent,
			componentProps: {
				appointmentId: this.appointmentId,
			},
			cssClass: 'full-screen-modal',
		});

		modal.onDidDismiss().then(async () => {
			await this.loadCharges();
		});

		return await modal.present();
	}

}
